import React from 'react'
import { Container } from 'react-bootstrap'
import ChoosePayMethod from '../../Components/PaymentPage/ChoosePayMethod'

const ChoosePayMethodPage = () => {
    return (
        <Container style={{minHeight:"630px"}}>
            <ChoosePayMethod/>
        </Container>
    )
}

export default ChoosePayMethodPage
